<template>
  <div class="Echarts">
    <!--  -->
    <div :id="id" style="width: 1000px; height: 370px"></div>
  </div>
</template>

<script>
const echarts = require("echarts");
let frameColor = "#999";
let lineColor = "#10a4f1";
let pointColor = "#10a4f1";
export default {
  name: "Echarts",
  props: ["message", "istoFixed", "text"],
  data() {
    return {
      state: false,
      id: Math.random().toString(36).substr(2),
      //        myparameter_type : this.message.type,
      //        myparameter_a :this.message.a,
      //        myparameter_b :this.message.b,
      //
      //        y : [0.9,0.7,0.5,0.1,0.05],
    };
  },
  watch: {
    message(val, newval) {
      this.myEcharts();
    },
  },
  methods: {
    myEcharts() {
      var self = this;
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      newPromise.then(() => {
        var lineChart = echarts.init(document.getElementById(this.id));
        // const  lineChart= echarts.init(document.getElementById('lineChart'));
        const lineOption = {
          animation: true,
          // title: {
          //     text: '网站访问渠道统计'
          // },
          tooltip: {
            trigger: "axis",
            formatter: function (params) {
              params = params[0];
              var date = new Date(params.value[0]);
              if (self.istoFixed) {
                return (
                  "<div style='text-align: left;'>" +
                  params.value[0] +
                  "</div> " +
                  "<span>" +
                  self.text +
                  "</span> : " +
                  params.value[1].toFixed(1)
                );
              } else {
                return (
                  "<div style='text-align: left;'>" +
                  params.value[0] +
                  "</div> " +
                  "<span>" +
                  self.text +
                  "</span> : " +
                  params.value[1]
                );
              }
              // return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' : ' + params.value[1];
            },
            axisPointer: {
              animation: true,
            },
          },
          legend: {
            data: [],
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          // toolbox: {
          //     feature: {
          //         saveAsImage: {}
          //     }
          // },
          xAxis: {
            type: "time", // type为time时,不要传xAxis.data的值,x轴坐标的数据会根据传入的时间自动展示
            boundaryGap: false, // false横坐标两边不需要留白
            splitLine: {
              show: false,
            },
            axisLabel: {
              showMaxLabel: true,
              formatter: (value, index) => {
                let xDate = new Date(value);
                return xDate.getMonth() + 1 + "/" + xDate.getDate();
              },
            },
          },
          yAxis: {
            type: "value",
            // name: '访问人数'
          },
          series: [],
        };
        // 获取动态数据的函数
        getData();
        function getData() {
          const data = [
            {
              // type: 'video',
              // name: '视频广告',
              data: self.message,
            },
          ];
          const series = [];
          const legendData = [];
          data.forEach((item) => {
            const obj = {
              showSymbol: false,
              clip: true,
              type: "line",
              hoverAnimation: false,
              data: item.data,
            };
            legendData.push(item.name);
            series.push(obj);
          });
          lineOption.legend.data = legendData;
          lineOption.series = series;
          // 第二个参数true表示清空之前的echarts设置,重新设置option,适用于legend等数据变化
          // 如果只是渲染数据变化可以不传,lenged等不会重新渲染
          lineChart.setOption(lineOption, true);
        }
      });
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      self.myEcharts();
    });
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Operational_data/views/chart.vue